import {
  Grid, Paper, Table, TableHead, TableBody, TableRow, TableCell, Button,
  Select, MenuItem, InputLabel, FormControl, Typography, useMediaQuery, TableContainer
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { ArrowDropDown, Settings } from "@mui/icons-material";
import { usePlaidLink } from "react-plaid-link";
import axios from "axios";
import axiosInstance from "../../../utils/axios/axiosInstance";
import Search from "../../../components/common/search/Search";
import store from "../../../store/store";
import { Add } from "@mui/icons-material";
import loader from "../../../components/Assets/images/loading.gif";

const Accountoverview = () => {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("");
  const [settings, setSettings] = useState(false);
  const [linkToken, setLinkToken] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const isLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const hasLinkedAccount = accounts.length > 0;
  const [loading, setLoading] = useState(true);

  // ✅ Step 1: Send bearer token once to backend
  useEffect(() => {
    const sendBearerTokenToBackend = async () => {
      const state = store.getState();
      const token = state.user?.accessToken;
      if (!token) return;
      try {
        await axios.post("https://plaid-2i1u.onrender.com/api/store-bearer-token", { token });
        console.log("Bearer token sent to backend");
      } catch (err) {
        console.error("Failed to send bearer token:", err);
      }
    };

    sendBearerTokenToBackend();
    fetchAndStore();
  }, []);



  const fetchAndStore = async () => {
    setLoading(true); // Start loader
    try {
      const accountsRes = await axios.get("https://plaid-2i1u.onrender.com/api/accounts");
      const transactionsRes = await axios.get("https://plaid-2i1u.onrender.com/api/transactions");

      setAccounts(accountsRes.data);
      setTransactions(transactionsRes.data);
    } catch (err) {
      console.error("Failed fetching from backend:", err);
      await fetchLinkToken(); // fallback
    } finally {
      setLoading(false); // End loader
    }
  };



  const fetchLinkToken = async () => {
    try {
      const response = await axios.post("https://plaid-2i1u.onrender.com/api/create-link-token");
      setLinkToken(response.data.link_token);
    } catch (err) {
      console.error("Error creating link token", err);
    }
  };

  const onSuccess = async (public_token) => {
    try {
      await axios.post("https://plaid-2i1u.onrender.com/api/exchange-public-token", { public_token });
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000); // auto-hide after 3 sec
      fetchAndStore();
    } catch (err) {
      console.error("Error exchanging token", err);
    }
  };

  const { open, ready } = usePlaidLink({ token: linkToken, onSuccess });

  const handleLogout = () => {
    // localStorage.removeItem("plaid_accounts");
    // localStorage.removeItem("plaid_transactions");
    setAccounts([]);
    setTransactions([]);
    fetchLinkToken();
  };

  const handleFilterChange = (event) => setFilter(event.target.value);

  const filteredTransactions = transactions.filter((txn) => {
    const categoryPrimary = txn.personal_finance_category?.primary?.toLowerCase() || "";
    const isCategoryMatch = filter ? categoryPrimary === filter.toLowerCase() : true;
    const isSearchMatch = txn.name.toLowerCase().includes(searchQuery.toLowerCase());
    return isCategoryMatch && isSearchMatch;
  });


  const Loader = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',      // Full height of the screen
      width: '100vw',       // Full width of the screen
      flexDirection: 'column',
      zIndex: 9999,             // Optional: stay on top
      position: 'fixed',        // Optional: overlay entire window
      top: 0,
      left: 0,
    }}>
      <img src={loader} alt="loading" style={{ width: '80px' }} />
      <Typography variant="h6" className="mt-2 loading-msg"></Typography>
    </div>
  );


  const SuccessAlert = () => (
<div style={{
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    color: '#256029',
    padding: '24px 32px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    animation: 'fadeIn 0.3s ease-in-out'
  }}>
    <img
      src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
      alt="Success"
      style={{ width: 36, height: 36, marginRight: 16 }}
    />
    <strong style={{ fontSize: '18px' }}>Bank account linked successfully!</strong>
  </div>
);



  return loading ? <Loader /> : (



    <Grid container spacing={2}>
       {showSuccessAlert && <SuccessAlert />}
      <div className="container">
        <div className="css-11ezll3-MuiToolbar-root">

          <div className="top-sec">
            <div className="card custom-card">

              <div class="card-body ">





                <div className="d-flex align-items-center justify-content-between flex-wrap pb-1">
                  <div class="d-flex align-items-center">
                    <h3 class="mb-2"> Account Overview</h3>
                  </div>
                  <div class="d-flex align-items-center flex-wrap mb-1">
                    {hasLinkedAccount
                      ? <Button variant="outlined" color="secondary" fullWidth onClick={handleLogout}>
                        Logout
                      </Button>
                      : <Button startIcon={<Add />} variant="contained" color="primary" fullWidth onClick={() => open()} disabled={!ready}>
                        Link your bank account </Button>
                    }
                  </div>
                </div>



                <div className="row filter-panel mt-4">
                  <div className="col-md-4">
                    <div className="serarch-bar">
                      <Search value={searchQuery} handleInputChange={(e) => setSearchQuery(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                  <div className="col-md-2  market-filter">
                    <div className="w-full flex items-center justify-end">
                      <FormControl variant="outlined" fullWidth className="filter">
                        <InputLabel>Filter By Category</InputLabel>
                        <Select value={filter} onChange={handleFilterChange} label="Filter By Category">
                          <MenuItem value="">All</MenuItem>
                          <MenuItem value="FOOD_AND_DRINK">Food</MenuItem>
                          <MenuItem value="ENTERTAINMENT">Entertainment</MenuItem>
                          <MenuItem value="SHOPPING">Shopping</MenuItem>
                          <MenuItem value="TRANSPORTATION">Transport</MenuItem>
                        </Select>
                      </FormControl>

                    </div>
                  </div>
                </div>

                <div className="row mt-5">
                  <div class="col-md-3 col-6 text-center">
                    <div class="task-box primary mb-0">
                      {accounts.map((account, idx) => (
                        <Paper elevation={2} className="p-4">
                          <p className="font-semibold text-gray-800">{account.name}</p>
                          <h3 className="text-xl font-bold text-primary">${account.balances.current}</h3>
                        </Paper>
                      ))}
                    </div>
                  </div>
                </div>


                <div className="d-flex align-items-center justify-content-between flex-wrap pb-1 mt-5">
                  <div class="d-flex align-items-center">
                    <h3 class="mb-2"> Recent Transactions</h3>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-md-12">
                    <div class="table-responsive mb-0">
                      <TableContainer className="table table-hover table-bordered mb-0 text-md-nowrap text-lg-nowrap text-xl-nowrap table-striped">
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell><strong>Name</strong></TableCell>
                              <TableCell><strong>Date</strong></TableCell>
                              <TableCell><strong>Amount</strong></TableCell>
                              <TableCell><strong>Category</strong></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {filteredTransactions.map((txn, index) => (
                              <TableRow key={index}>
                                <TableCell>{txn.name}</TableCell>
                                <TableCell>{txn.date}</TableCell>
                                <TableCell>${txn.amount}</TableCell>
                                <TableCell>{txn.personal_finance_category?.primary || "-"}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>



              </div>

            </div>
          </div>



        </div>
      </div>





    </Grid>
  );
};

export default Accountoverview;
